import { Tag, Typography } from 'antd';

import { Toggle } from '../../form/Toggle';
import ArrowUpRight from '../../icons/ArrowUpRight';
import { HelpText } from '../../ui/HelpText';

type UpgradeFeatureItemProps = {
  title: string;
  description: string;
  conversionRate: string;
  toggle: {
    id: string;
    name: string;
  };
};

const UpgradeFeatureItem = ({ title, description, conversionRate, toggle }: UpgradeFeatureItemProps) => {
  return (
    <div className='flex flex-col gap-4 py-4'>
      <div className='flex items-center justify-between'>
        <div className='flex flex-col gap-1'>
          <Typography.Text strong>{title}</Typography.Text>
          <HelpText size='sm'>{description}</HelpText>
          <Tag color='green' className='flex! w-fit items-center! gap-1'>
            <ArrowUpRight />
            {conversionRate}
          </Tag>
        </div>
        <div>
          <Toggle id={toggle.id} name={toggle.name} />
        </div>
      </div>
    </div>
  );
};

export default UpgradeFeatureItem;
